import React from "react";
import "./card2.css";
// import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
// import {
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow
// } from "@material-ui/core";

function MediaCard3(props) {
  const formatDate = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      date = `${dd}/${mm}/${yyyy}`;
      return date;
    }

    return;
  };


  const history = useHistory();

  const onNameClick = row => {

    props.onHandleCampaign(row);
    localStorage.setItem("label", "Leads");
    history.push("/campaigns");

  };

  const rows = props.DashboardData[7];

  return rows.map(row => (
    <div className="item">
      <div className="profile-img-box">
        <img
          src={row.profileimage != null ? row.profileimage : "img/loginbg.jpg"}
        />
      </div>
    
      <div className="detail-box">
        <h3 className="name" component="th"
          scope="row" style={{ cursor: "pointer" }}
          onClick={() => onNameClick(row)}>
          {row.name}{" "}
          <span>{row.contactStatus !== null ? row.contactStatus : ""}</span>

        </h3>

        <div className="address-text">
          {row.designation !== null && row.designation !== "" ? row.designation + "," : ""} {" "}
          {row.location !== null ? row.location : ""}
        </div>


        <div className="date-info">
          {" "}
          Connected on{" "}
          {row.connectedOn !== null ? formatDate(row.connectedOn) : " "}{" "}
          <span>
            {" "}
            Last response on{" "}
            {row.lastResponse !== null ? formatDate(row.lastResponse) : ""}
          </span>
        </div>
        <div className="stage-text">
          {row.currentstatus !== null ? row.currentstatus : ""}
        </div>
      </div>
    </div>
  ));

  function onClickCard(currentHeader) {
    props.onClickCard(currentHeader);
  }

}
const mapDispatchToProps = dispatch => {

  return {
    onHandleCampaign: data =>
      dispatch({
        type: "Campaign_Detail",
        payload: data
      })
  };
};
export default connect(null, mapDispatchToProps)(MediaCard3);

